export default class GlobalEvents {
  static refreshCanvas = () => {
    window && window.dispatchEvent(new Event("refreshCanvas"));
  };
}
